import { PAGE_KINDS } from "../shared/constants/pageAgentIds";
import { FRONTEND_TOOL_CODES, FRONTEND_TOOL_NAMES } from "./frontendToolNames";
import { refuse, type FrontendTool } from "./frontendTool";

/** Closes whichever panel is open and shows the section again. */
export const closePanelTool: FrontendTool = {
  name: FRONTEND_TOOL_NAMES.closePanel,
  declaration: (location, caseReview) => location?.page !== PAGE_KINDS.caseReview || caseReview === null ? null : {
    name: FRONTEND_TOOL_NAMES.closePanel,
    description: "Close the open panel and show the case's section again.",
    parameters: { type: "object", properties: {} },
  },
  execute: (_args, env) => {
    if (env.caseReview === null) return refuse(FRONTEND_TOOL_CODES.outOfScope, "No case is open on this screen.");
    env.caseReview.setActivePanelId(null);
    return { ok: true, panelId: null };
  },
};
